import {Selectors} from '../selectors/selectors';
import {Actions} from '../actions/actions';

export const seedSampleData = async (selectors: Selectors, actions: Actions, mode: 'remote' | 'local') => {

};
